import React from "react";
import { Grid, Typography } from "@mui/material";
import BookingTypeListTemplate from "./bookingTypeListTemplate";  
import { getCategoryName } from "../../../util/utils";

const BusinessBookingTypeList = ({
  business,
  primaryColor= null,
  embeded = false,
  url = null,
}) => {
  const getBookingPath = (bookingType) => {
    return `/${business?.url ?? url}/booking/${bookingType.link}`; // Dynamic path
  };

  // Filter all booking types to include only those with isPublic === true
  const publicBookingTypes = business.businessBookingTypes.filter(
    (bookingType) => bookingType.isPublic && bookingType.displayOnBookingPage
  );

  // Group booking types by categoryId (1, 2, 3)
  const categories = [1, 2, 3];

  return (
    <Grid container spacing={2}>
      {categories.map((categoryId) => {
        const filteredBookingTypes = publicBookingTypes.filter(
          (type) => type.bookingTypeCategoryId === categoryId
        );

        if (filteredBookingTypes.length > 0) {
          const categoryName = getCategoryName(categoryId) 

          return (
            <Grid item xs={12} key={categoryId}>
              <Typography>{categoryName}</Typography>
              <BookingTypeListTemplate
                bookingTypes={filteredBookingTypes}
                category={categoryId}
                primaryColor={primaryColor}
                embeded={embeded}
                getBookingPath={getBookingPath} // Pass the function as the prop
              />
            </Grid>
          );
        }

        return null;
      })}
    </Grid>
  );
};

export default BusinessBookingTypeList;
